import styled from "@emotion/styled";
import { Typography } from "antd";
import { FC, ReactNode } from "react";
import { goBack } from "assets/icons";

type ManageParcelPageHeaderProps = {
  title: string;
  onBack: () => void;
  rightSlot?: ReactNode;
};

const ManageParcelPageHeader: FC<ManageParcelPageHeaderProps> = ({
  title,
  onBack,
  rightSlot,
}) => {
  return (
    <HeaderTabs>
      <IconWrapper onClick={onBack}>
        <SpanIcon>{goBack}</SpanIcon>
      </IconWrapper>
      <Typography.Title level={5}>{title}</Typography.Title>
      <RightIconWrapper>{rightSlot}</RightIconWrapper>
    </HeaderTabs>
  );
};

export default ManageParcelPageHeader;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 40px;
`;
